import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'admin-on-rest';
import { FETCH_START, FETCH_END } from 'admin-on-rest/lib/actions/fetchActions';
import get from 'lodash.get';
import fetcher from '../helpers/fetcher';

let promiseResolverError;
let promiseResolverLoadingStart;
let promiseResolverLoadingEnd;

const getErrorMessage = error => {
  return (get(error, 'data.message') || get(error, 'message') || error) + '';
};

fetcher.interceptors.request.use(
  config => {
    if (promiseResolverLoadingStart) {
      promiseResolverLoadingStart(true);
    }
    return config;
  },
  error => {
    if (promiseResolverLoadingEnd) {
      promiseResolverLoadingEnd(true);
    }
    return Promise.reject(error);
  }
);

fetcher.interceptors.response.use(
  response => {
    if (promiseResolverLoadingEnd) {
      promiseResolverLoadingEnd(true);
    }
    return response;
  },
  error => {
    if (promiseResolverLoadingEnd) {
      promiseResolverLoadingEnd(true);
    }
    // Do something with response error
    if (promiseResolverError) {
      promiseResolverError(error);
    }
    if (
      error &&
      (error.status === 401 ||
        getErrorMessage(error).indexOf('status code 401') > -1 ||
        getErrorMessage(error).indexOf('No auth token') > -1)
    ) {
      console.log('unauthorized, logging out ...');
      window.location.replace('#/login');
    }
    return Promise.reject(getErrorMessage(error));
  }
);

function onError() {
  const promise = new Promise(resolve => {
    promiseResolverError = resolve;
  });
  return promise;
}

export function* startErrorWatcher() {
  while (true) {
    const error = yield onError();
    if (error && error.length) {
      yield put(showNotification(error, 'warning'));
    }
  }
}

// Our watcher Saga: spawn a new incrementAsync task on each INCREMENT_ASYNC
export function* axiosErrorSaga() {
  yield takeEvery('AOR/DECLARE_RESOURCES', startErrorWatcher);
}

function onLoadingStart() {
  const promise = new Promise(resolve => {
    promiseResolverLoadingStart = resolve;
  });
  return promise;
}

function onLoadingEnd() {
  const promise = new Promise(resolve => {
    promiseResolverLoadingEnd = resolve;
  });
  return promise;
}

export function* startLoadingStartWatcher() {
  while (true) {
    const loading = yield onLoadingStart();
    if (loading) {
      yield put({ type: FETCH_START });
    }
  }
}

export function* startLoadingEndWatcher() {
  while (true) {
    const loadingEnd = yield onLoadingEnd();
    if (loadingEnd) {
      yield put({ type: FETCH_END });
    }
  }
}

export function* axiosLoadingStartSaga() {
  yield takeEvery('AOR/DECLARE_RESOURCES', startLoadingStartWatcher);
}

export function* axiosLoadingEndSaga() {
  yield takeEvery('AOR/DECLARE_RESOURCES', startLoadingEndWatcher);
}



// WEBPACK FOOTER //
// ./src/sagas/axios.js